import type { IndustryCodeName } from "app/pages/sales-intelligence/domain/industry/types/codes";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

export default function createIndustryCodesFilterEventsTrackingService(track: TrackFn) {
    return {
        trackIndustryCodesBulkAddClick(type: IndustryCodeName) {
            track("lead gen filters", "click", createTrackingEventName(`add bulk codes`, type, "naics", "sic code"));
        },
        trackIndustryCodesBulkAddModalButtonClick(type: IndustryCodeName, buttonClicked: "add" | "cancel") {
            track("naics/sic codes popup", "click", createTrackingEventName(buttonClicked, type, "naics", "sic code"));
        },
        trackingIndustryCodesChange(type: IndustryCodeName, action: "select" | "unselect" | "remove") {
            track("lead gen filters", "click", createTrackingEventName(`${action} code`, type, "naics", "sic code"));
        },
    };
}
